// extracted by mini-css-extract-plugin
module.exports = {"icon":"Switch_icon__2_ue3","buttonGroupLabel":"Switch_buttonGroupLabel__RwEN5","toggle":"Switch_toggle__2pAya","add":"Switch_add__eUu-Q"};